import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addSkillQuiz } from "../../Services/SkillService";
import { getAllQuiz } from "../../Services/QuizService";

const AddSkillQuiz = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: null,
        skill_id: null,
        quiz_id: null,
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);

    const [previewImage, setPreviewImage] = useState({
        logo: ""
    });

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await addSkillQuiz(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getStatusCall = async () => {
        let { ok, data } = await getAllQuiz({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    useEffect(() => {
        getStatusCall();
        if (data?.data) {
            const { id, skill_id } = data?.data;
            setReqData({ quiz_id: id, skill_id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">Add Quiz</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Quiz</label>
                                            <select required value={reqData?.quiz_id} onChange={(e) => handleChange("quiz_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select Quiz</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddSkillQuiz;